import errors from 'common-errors'; // https://github.com/shutterstock/node-common-errors#readme

const ERRORDUPLICATEWHATSAPP = 'Existen más contactos con el mismo número de teléfono';
const ERRORWHATSAPP = '##DuplicateNumberForWhatsapp';

export default class ApiClient {
  constructor(restClient, event) {
    this.event = event;
    this.restClient = restClient;
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(response) {
    if (response && response.status) {
      const { status, statusText, data } = response;
      if (this.event != null && status === 401) {
        // handle session logout
        this.event.emit('api:unauthorized');
      }
      if (typeof data === 'string' && data.includes(ERRORDUPLICATEWHATSAPP)) {
        return new errors.HttpStatusError(status, `${ statusText }${ ERRORWHATSAPP }`);
      }
      const httpStatusError = new errors.HttpStatusError(status, statusText, data);
      httpStatusError.data = data;
      return httpStatusError;
    }
    return new errors.Error(response.message || response);
  }

  set baseURL(baseURL) {
    this.restClient.defaults.baseURL = baseURL;
  }

  get baseURL() {
    return this.restClient.defaults.baseURL;
  }

  set accessKey(accessKey) {
    this.restClient.defaults.headers['x-accesskey'] = accessKey;
  }

  get accessKey() {
    return this.restClient.defaults.headers['x-accesskey'];
  }

  set jwtToken(jwtToken) {
    this.restClient.defaults.headers['x-jwt-token'] = jwtToken;
  }

  get jwtToken() {
    return this.restClient.defaults.headers['x-jwt-token'];
  }
}
